import { userInfoSync } from 'hub-http/userInfo';
const getGatesAsSet = () => {
  try {
    return new Set(userInfoSync().gates);
  } catch (e) {
    return new Set();
  }
};
export const isUngatedFor = (() => {
  const cacheResults = new Map();
  let cachedGates = new Set();
  return gateName => {
    if (cacheResults.has(gateName)) return cacheResults.get(gateName);
    if (!cachedGates) {
      cachedGates = getGatesAsSet();
    }
    const hasGate = cachedGates.has(gateName);
    cacheResults.set(gateName, hasGate);
    return hasGate;
  };
})();